import { useScreenSize, useWindowHeight } from "@telefonica/mistica";
import { HEIGHT_GRID_LOGO } from "../../constants";

interface HeightValues {
	height: number;
	barPadding: 16 | 24;
	barHeight: 0 | 56 | 76;
}

export const useScreenViewHeight = (navigationBar: boolean): HeightValues => {
	const { isDesktopOrBigger } = useScreenSize();
	const screenHeight = useWindowHeight();

	const navigationBarHeight = !navigationBar ? 0 : isDesktopOrBigger ? 76 : 56;
	const navigationBarPadding = isDesktopOrBigger ? 24 : 16;

	const height = screenHeight - navigationBarHeight - HEIGHT_GRID_LOGO;

	return { height, barPadding: navigationBarPadding, barHeight: navigationBarHeight };
};
